import { render, staticRenderFns } from "./Leaguedetail.vue?vue&type=template&id=777ecc88&"
import script from "./Leaguedetail.vue?vue&type=script&lang=js&"
export * from "./Leaguedetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports